import cn from 'classnames';
import type { FC } from 'react';
import type React from 'react';

import { useMobile } from '@shared/hooks';

import type { ModalProps } from '@src/library/components/common/modals/ModalLarge/ModalLarge';

import { ModalLarge, ModalMiddle } from 'library/components/common';

import * as st from './styles.module.scss';

interface Props extends ModalProps {
	isLarge: boolean;
	isOpen: boolean;
	children?: React.ReactNode;
	close?: () => void;
	onRequestClose?: () => void;
	info?: string;
	title?: string;
	className?: string;
	disableHeader?: boolean;
}

export const ModuleWrapper: FC<Props> = ({ children, isLarge, className, ...props }) => {
	const { isMobile } = useMobile();

	if (isMobile) {
		return <div className={cn(st.mobile, className)}>{children}</div>;
	}

	if (isLarge) {
		return <ModalLarge {...props}>{children}</ModalLarge>;
	}

	return (
		<ModalMiddle className={className} {...props}>
			{children}
		</ModalMiddle>
	);
};
